export const terms = [
  {
    term: 'ABI',
    description:
    '<strong>A</strong>pplication <strong>B</strong>inary <strong>I</strong>nterface: Das Binärinterface, das zum Datenaustausch verwendet wird, z.B. die Registerverwendung in einer Funktion und für Parameterübergabe, Datenablage, Strukturlayout, etc. Jeder Compiler erzeugt Code nach einer bestimmten ABI, so dass der Code aus unterschiedlichen Modulen und Bibliotheken zusammenpasst. Beim Mischen von Hochsprachen mit (Inline-)Assembler muss auf ABI-Konformität geachtet werden. Compiler-Schalter können das ABI beeinflussen. Beispiel: -fpack-struct beim GCC.'
  },
  {
    term: 'ADC',
    description: "<strong>A</strong>nalog <strong>D</strong>igital <strong>C</strong>onverter. Im Deutschen auch 'ADU' (Analog Digital Umsetzer)."
  },
  {
    term: 'ADSR',
    description:
      'Attack Decay Sustain Release. Ein Amplitudenverlauf als Hüllkurve, die hauptsächlich in der elektronischen Musik - aber auch bei der Verhaltensbeschreibung von Regelersystemen verwendet wird'
  },
  {
    term: 'AGC',
    description: 'Automatic Gain Control. Ein Schaltkreis oder eine Software zur selbsttätigen Verstärkungsanpassung in Form einer Regelung.'
  },
  {
    term: 'ARM',
    description: 'Advanced RISC Machine. Eine Mikrocontrollerfamilie des Types RISC ("reduced instruction set") bzw. die Firma, die diese designt und lizensiert.'
  },
  {
    term: 'AVR',
    description: 'Eine Mikrocontrollerfamilie von Atmel.'
  },
  {
    term: 'BGA',
    description: 'Ball Grid Array: Eine Gehäuseform für ICs.'
  },
  {
    term: 'Bit',
    description: 'Binary Digit: Kleinste Informationseinheit, siehe Bitmanipulation.'
  },
  {
    term: 'BNC',
    description: 'Bajonet Nut Connector: Ein Steckverbinder für Koaxialkabel.'
  },
  {
    term: 'BPM',
    description: 'Beats per minute: Anzahl der Herzschgläge bei Cardio-Applikationen / Zahl der Schlagzeugschläge je Minute in der Musik'
  },
  {
    term: 'BPS',
    description: 'Bits per second: Anzahl der Bits je Sekunde, Masszahl für die Übertragungsgeschwindigkeit / Bandbreite'
  },
  {
    term: 'BSDL',
    description: 'Boundary Scan Description Language: Eine Sprache für boundary scan-basiertes Testen und Debuggen.'
  },
  {
    term: 'C',
    description: 'Eine weit verbreitete Programmiersprache.'
  },
  {
    term: 'CAN',
    description: 'Controller Area Network: Ein Netzwerk für kleine Mikrocontroller, ursprünglich für die Automobilbranche entwickelt.'
  },
  {
    term: 'CCD',
    description: 'Charge Coupled Devices: (Ladungsverkoppelte Bauteile), eine Bezeichung für Bildsensoren'
  },
  {
    term: 'CDC',
    description: 'Cross Domain Crossing: ein Synonym für Taktübergänge in digitalen Schaltungen'
  },
  {
    term: 'CDC',
    description: 'Communication Device Class: Im USB-Standard festgelegte (OS-unabhängige) Emulation serieller Geräte über USB'
  },
  {
    term: 'CDS',
    description: 'Component Design Specification: formelle Designbeschreibung'
  },
  {
    term: 'CLB',
    description: 'Configurable Logic Block: elementares konfigurierbares Logikelement in PLDs'
  },
  {
    term: 'CMB',
    description: 'Command Management Block: der Befehlsinterpreter in einer CPU-Plattform, meist im Bereich der Kommunikationsschnittstelle, auch CMI'
  },
  {
    term: 'CMT',
    description: 'Clock Management Tile: Ein takterzeugendes Element in einem (Xilinx)-FPGA'
  },
  {
    term: 'CNC',
    description: 'Computerized Numerical Control: Computer gesteuerte Steuerung, z.B. bei Werkzeugmaschinen'
  },
  {
    term: 'CPLD',
    description: 'Complex Programmable Logic Device: Ein programmierbarer Logikbaustein'
  },
  {
    term: 'CRS',
    description: 'Component Requirement Specification: formelle Anforderungsspezifikation'
  },
  {
    term: 'DAC',
    description: 'Digital to Analog Converter'
  },
  {
    term: 'DCC',
    description: 'Digital Command Control: Standard zur digitalen Steuerung von Modelleisenbahnen'
  },
  {
    term: 'DCM',
    description: 'Digital Clock Manager, eine Takterzeugungseinheit in FPGAs'
  },
  {
    term: 'DDC',
    description: 'Digital Down Conversion: Abtastfrequenzverringerung in der Signalverarbeitung'
  },
  {
    term: 'DDR',
    description: 'Double Data Rate: "doppelte Datenrate", oft in Verbindung mit RAMs verwendet'
  },
  {
    term: 'DDS',
    description: 'Digital Data Storage: Bezeichung für grosse Massenspeicher in der Computertechnik'
  },
  {
    term: 'DDS',
    description: 'Direct Digital Synthesis: Verfahren zur Wellenformerzeugung - i.d.R ein Sinus'
  },
  {
    term: 'DFS',
    description: 'Digital Frequency Synthesis: Allgemeiner Begriff bzw digitale Wellenformerzeugung'
  },
  {
    term: 'DMX',
    description: 'Protokoll zur Steuerung von Lichteffektgeräten'
  },
  {
    term: 'DRC',
    description: 'Design Rule Check, ein Prüfvorgang auf geometrische Fehler in einem PCB-Layout'
  },
  {
    term: 'DTMF',
    description: 'Dual Tone Multiple Frequency: Tonwahlverfahren im Telephon'
  },
  {
    term: 'DUC',
    description: 'Digital Up Conversion: Abtastfrequenzerhöhung in der Signalverarbeitung'
  },
  {
    term: 'EDO',
    description: 'Enhanced Data Out, ein (inzwischen veraltetes) Datenformat beim RAMs.'
  },
  {
    term: 'EEPROM',
    description: 'Electrical Erasable and Programmable Read Only Memory: Ein nichtflüchtiger Speicher.'
  },
  {
    term: 'EMV',
    description:
      'Elektromagnetische Verträglichkeit: Beschreibt das Verhalten von Geräten bezüglich Aussenden von elektromagetischen Störungen und die Toleranz bezüglich Einstrahlung eben dieser.'
  },
  {
    term: 'ERC',
    description: 'Electrical Rule Check, ein Prüfvorgang auf Fehler in einem PCB-Layout, bzw einem Schaltplan.'
  },
  {
    term: 'ESR',
    description: 'Equivalent Series Resistance, der effektive innere Widerstand von z.B. Kondensatoren.'
  },
  {
    term: 'FBGA',
    description: 'Fine Ball Grid Array: Eine Gehäusebauform für ICs.'
  },
  {
    term: 'FCU',
    description: 'Flow Control Unit: eine logische Einheit in einem Microcontroller oder einem FPGA, welche einen Datenfluss steuert, z.B. in einer Rechenpipeline'
  },
  {
    term: 'FEC',
    description:
      'Forward Error Correctopn: Fehlerkorrekturverfahren, welches die Paritätsinformation vor den eigentlichen Daten sendet und somit eine on the fly Korrektur im Empfänger ermöglicht'
  },
  {
    term: 'FEM',
    description: 'Finite Elemente Methode: Rechenverfahren, das mittels Stützstellenapproximation und Minimierung eines Energiefunktionals Systemzustände ermittelt'
  },
  {
    term: 'FFT',
    description:
      'Fast Fourier Transformation: Ein Algorithmus zur effizienten Berechnung der Diskreten Fourier-Transformation für den Fall gleicher Zeitabstände der Eingabewerte und einer Zweierpotenz als Anzahl der Eingabewerte. Die Fourier-Transformation bildet eine Funktion auf ihr Frequenzspektrum ab, was vielfach in der Signalverarbeitung Anwendung findet neben anderen Transformationen wie Laplace-Transformation, Wavelet-Transformation oder Z-Transformation.'
  },
  {
    term: 'FI',
    description: 'Fehlerstromschutzschalter (Ein anderer Name für RCD.)'
  },
  {
    term: 'FIFO',
    description: 'First In First Out: Eine Organisationsform für einen Zwischenspeicher, bei dem die Daten in der Reihenfolge ausgegeben werden, in der sie eingeschrieben wurden'
  },
  {
    term: 'FMEA',
    description: 'Fault Mode Effect Analsys, englisch für die Analyse von Funktionsfehlern eines Systems infolge äusserer Einflüsse, deutsch auch "Fehlermöglichkeitseinflussanalyse"'
  },
  {
    term: 'FOC',
    description: 'Field Oriented Control, englisch für feldorientierte Regelung (bei Motoren)'
  },
  {
    term: 'FPGA',
    description: 'Field Programmable Gate Array: Bezeichnung für jederzeit wieder programmierbare Logikbausteine.'
  },
  {
    term: 'FPU',
    description: 'Floating Point Unit: Teil eines Prozessors, der Berechnungen mit Gleitkommazahlen unterstützt.'
  },
  {
    term: 'FSM',
    description:
      'Finite State Machine, englisch für Zustandsautomat; eine Schaltung, die einen Ablauf in Form einer Software realisiert, z.B. in einem Microcontroller oder auch einem Logikbaustein'
  },
  {
    term: 'GFCI',
    description: 'Ground Fault Current Interrupter: eine Art RCD eingebaut in eine Steckdose. Bei Steckdosen für draußen und im Bad in Nordamerika anzutreffen.'
  },
  {
    term: 'GFR',
    description: 'General Function Register: s.u.'
  },
  {
    term: 'GPR',
    description:
      'General Purpose Register: Arbeitsregister eines Prozessors. Bei vielen Architekturen müssen Daten in solche Register geladen werden, um sie bearbeiten zu können. Bei AVR sind das die Register R0 - R31'
  },
  {
    term: 'GMII',
    description: 'Gigabit Media Independent Interface, ein MII für Gigabit-PHYs'
  },
  {
    term: 'GPS',
    description: 'Global Positioning System'
  },
  {
    term: 'GPU',
    description: 'Graphic Processing Unit, eine Grafikverarbeitungseinheit, meist für die Grafikarte in Rechnern verwendet, oft auch im Zusammenhang mit der Benutzung derselben als Coprozessor'
  },
  {
    term: 'GSM',
    description:
      'Global System for Mobile Communications: Das Mobilfunknetz der zweiten Generation (auch 2G genannt). Darüber können Gespräche (circuit switched) und Daten (packet switched, GPRS) übertragen werden.'
  },
  {
    term: 'GTP',
    description: 'Gigabit Transceiver Port: Ein high speed port bei FPGAs'
  },
  {
    term: 'HF',
    description: 'Hochfrequenz'
  },
  {
    term: 'HIL',
    description: 'Wikipedia: Hardware in the Loop.'
  },
  {
    term: 'HP',
    description: 'Horse Power, engl. Bezeichnung für mechanische Leistung, siehe Pferdestärek'
  },
  {
    term: 'HPF',
    description: 'High Pass Filter: Englisch für Hochpass-Filter, seltener auch nur HP'
  },
  {
    term: 'IIR',
    description: 'Infinite Impulse Response: Bezeichnet ein bestimmte Sorte von Filtern, mit unendlicher Sprungantwort.'
  },
  {
    term: 'ISA',
    description: 'Instruction Set Architecture: Registerstruktur und Befehlssatz eines Prozessors/Mikrocontrollers bzw. einer Prozessorfamilie.'
  },
  {
    term: 'ISP',
    description: 'In System Programming: Der Mikrocontroller wird direkt auf der Zielhardware programmiert.'
  },
  {
    term: 'ISR',
    description: 'Interrupt Service Routine: Ein Programmstück, das nach Eintreten eines bestimmten Ereignisses ausgeführt wird. Siehe Interrupt.'
  },
  {
    term: 'IRQ',
    description:
      'Interrupt Request: Ein Ereignis, das einen Interrupt auslöst. In der Regel wird die Programmausführung unterbrochen und ein spezielles Programmstück, eine ISR, ausgeführt und danach zum ursprünglichen Programmcode zurückgekehrt. Viele IRQs können aktiviert oder deaktiviert werden.'
  },
  {
    term: 'JTAG',
    description: 'Joint Test Action Group: Eine Funktion für komplexe ICs, um diese im aufgelöteten Zustand zu prüfen bzw. zu programmieren und debuggen (Mikrocontroller).'
  },
  {
    term: 'KDE',
    description: 'Oberfläche bei Linux'
  },
  {
    term: 'LIFO',
    description: 'Last In First Out, azyklisch beschriebener Speicher, der wie ein Stapel (stack) arbeitet'
  },
  {
    term: 'LPF',
    description: 'Low Pass Filter: Englisch für TiefpassFilter, teilweise auch nur LP'
  },
  {
    term: 'LSB',
    description: 'Least Significant Byte: Das niederwertigste Byte in einem Datenwort mit mehreren Bytes. Je nach Zusammenhang aber auch'
  },
  {
    term: 'LTE',
    description: 'Long Term Evolution: LTE ist ein Mobilfunkstandard und auch als 4G (fourth generation) bekannt. Der Vorgänger von LTE ist 3G (third generation).'
  },
  {
    term: 'MAC',
    description: 'Media Access Controller: Bezeichnung für die Logik, die einen Baustein steuert, meist im Zusammenhang mit Ethernet verwendet'
  },
  {
    term: 'MCB',
    description: 'Main Control Block: Eine allgemeine Bezeichnung für die zentrale Steuerlogik in einem System'
  },
  {
    term: 'MCU',
    description: 'Main Control Unit: Die zentrale Steuerlogik in einem System, auch CPU'
  },
  {
    term: 'MIG',
    description: 'Memory Interface Generator: Eine Software, die ein Speicherinterface in FPGAs konfiguriert'
  },
  {
    term: 'MII',
    description: 'Media Independent Interface, ein Begriff für ein allgemeines, bausteinunabhängiges Interface, oft in Verbindung mit Ethernet-PHYs verwendet'
  },
  {
    term: 'MIPS',
    description: 'Million instructions per second'
  },
  {
    term: 'MMC',
    description: 'Multi Media Card: Eine kleine Speicherkarte'
  },
  {
    term: 'MSB',
    description: 'Most Significant Byte: Das höchstwertige Byte in einem Datenwort mit mehreren Bytes. Je nach Zusammenhang aber auch'
  },
  {
    term: 'Modbus',
    description: 'Ein älteres, aber immer noch oft eingesetztes Busprotokoll für serielle Verbindungen. In der Modbus TCP-Variante auch ethernetfähig'
  },
  {
    term: 'NCO',
    description: 'Numeric Controlled Oscillator. Ein numerisch/digital arbeitender Schwingkreis - siehe auch DDS.'
  },
  {
    term: 'OCDS',
    description: 'On Chip Debug Support'
  },
  {
    term: 'PAM',
    description: 'Pulse Amplituden Modulation: Umsetzung eines Wertes auf analoge Spannungszustände, z.B. bei Ethernet'
  },
  {
    term: 'PCM',
    description: 'Pulse Code Modulation: Umsetzung eines analogen Wertes auf ein digitales Signal - auch als Begriff für das Datenformat verwendet. Siehe Pulscodemodulation'
  },
  {
    term: 'PDM',
    description: 'Pulse Dichte Modulation: Umsetzung eines Wertes auf ein 1-Bit Signal, siehe Pulsdichtemodulation'
  },
  {
    term: 'PFC',
    description: 'Power Factor Correction: Eine Schaltung, die Blindleistung kompensiert'
  },
  {
    term: 'PHY',
    description: 'Bezeichnung für einen physikalischen Chip, oft im Zusammenhang mit Ethernet verwendet'
  },
  {
    term: 'PLL',
    description: 'Phase Locked Loop: Eine Schaltung, die einen Ausgangstakt mit definierter Phaselage zu einem Eingangstakt generiert.'
  },
  {
    term: 'PSU',
    description: 'Power Supply Unit: Bezeichnung für die Stromversorgungseinheit'
  },
  {
    term: 'PWM',
    description: 'Pulse Weiten Modulation: Umsetzung eines Wertes auf 1-Bit Signal - siehe Pulsweitenmodulation'
  },
  {
    term: 'QAM',
    description: 'Qadratur Amplituden Modulation: Modulation eines Analogsignals mit einem Quadratursignal (IQ).'
  },
  {
    term: 'QDR',
    description: 'Qadruple Data Rate: Eine Speicherzugriffstechnik mit 4 Daten je Takt, siehe RAMs'
  },
  {
    term: 'RCCB',
    description: 'Residual Current operated Circuit Breaker - ist eine andere Bezeichnung für einen RCD.'
  },
  {
    term: 'RCD',
    description: 'Residual Current protective Device, neudeutsch für Fehlerstromschutzschalter.'
  },
  {
    term: 'RISC',
    description: 'Reduced Instruction Set Computer. Designstrategie für den Befehlssatz von Prozessoren und Microcontrollern, die einfache Befehle bevorzugt.'
  },
  {
    term: 'RS232',
    description: 'Recommended Standard 232: Eine Definition zur seriellen Datenübertragung, eng gekoppelt an UART. RS232 ist auch unter EIA232 bekannt.'
  },
  {
    term: 'RS485',
    description: 'Recommended Standard 485: Eine Definition zur seriellen Datenübertragung, eng gekoppelt an UART. RS485 ist differentiell, was Störfestigkeit erhöht. Auch unter EIA485 bekannt.'
  },
  {
    term: 'SAR',
    description:
      'Synthetic Aperture Radar: Eine Messwertverarbeitungsmethodik in der Radartechnik, bei der durch eine virtuelle Positionsvariation eine künstlich vergrösserte "Blende" benutzt werden kann, wodurch sich der Empfangsbereich stark vergrössert.'
  },
  {
    term: 'SAS',
    description:
      'Serial Attached SCSI: SAS ist eine Schnittstelle zur Anbindung von SSDs und Festplatten, welche meistens in Servern zu finden ist. Es gibt auch SAS Expander, mit welchen man an ein Interface noch mehr Datenträger hängen kann.'
  },
  {
    term: 'SATA',
    description: 'Sata ist eine Schnittstelle zur anbindung von Festplatten und SSDs innerhalb eines Computers. Der Nachfolger ist NVMe'
  },
  {
    term: 'SDF',
    description: 'Signal Delay File: Eine Datei für zeitgenaue Simulationen in der Digitaltechnik, welche die internen Zeitverzögerungen beschreibt.'
  },
  {
    term: 'SDR',
    description:
      'Software Defined Radio: Allgemeine Bezeichung für mathematisch - per Software erzeugte - und modulierte elektromagnetische Wellen in der HF-Technik, speziell der Funkdatenübertragung und Radartechnik.'
  },
  {
    term: 'SOC',
    description: 'System On Chip: Bezeichung für die Erzeugung ganzer, computerähnlicher Rechnersysteme in programmierbaren Schaltkreisen wie FPGAs.'
  },
  {
    term: 'SOP',
    description: 'Start Of Production: Ein Begriff aus dem Projektmanagement, der den Beginn der Produktion bezeichet.'
  },
  {
    term: 'SOP',
    description:
      'Standard Operation Procedure: Ein Begriff aus dem Qualitätsmanagement, der eine Test- und Prüfmethodik zur Qualifizierung von Systemen beschreibt. Wird teilweise auch als Anleitung für Benutzer verstanden.'
  },
  {
    term: 'SFR',
    description:
      'Special Function Register: Hardware-Register, über die interne und externe Peripherie eines Prozessors/Mikrocontrollers konfiguriert wird, und über die Daten ausgetauscht werden. IO-Ports werden z.B. auf bestimmte SFRs abgebildet, auf die dann mit speziellen Befehlen zugegriffen werden kann.'
  },
  {
    term: 'STM',
    description: 'Eine Microcontrollerfamilie der Firma S T Microelectronics.'
  },
  {
    term: 'TTL',
    description: 'Transistor-Transistor-Logik.'
  },
  {
    term: 'UART',
    description: 'Universal Asynchronus Receiver and Transmitter: Ein Modul in Mikrocontrollern oder PCs zum seriellen Datenaustausch.'
  },
  {
    term: 'USB',
    description: 'Universal Serial Bus : Ein standardisiertes serielles Protokoll, das vorwiegend bei PCs verwendet wird. Bandbreite beträgt bis zu 5Gbit/s.'
  },
  {
    term: 'VCA',
    description: 'Voltage Controlled Amplifier - Spannungsgesteuerter Verstärker'
  },
  {
    term: 'VCO',
    description: 'Voltage Controlled Oscillator - Spannungsgesteuerter Oszillator'
  },
  {
    term: 'VHDL',
    description: 'VHSIC Hardware Description Language - Programmiersprache für ASIC-und FPGA-Entwurfswerkzeuge'
  },
  {
    term: 'VHSIC',
    description: 'Very High Speed Integrated Circuit - allgemein für schnelle Digtialschaltungen'
  },
  {
    term: 'VLSI',
    description: 'Very Large Scale Integrated Circuit - allgemein für ASICS'
  },
  {
    term: 'WDT',
    description: 'Watch Dog Timer'
  },
  {
    term: 'Z',
    description: 'In der HF-Technik das Formelzeichen für den Wellenwiderstand.'
  },
  {
    term: 'Term',
    description: 'Description'
  },
  {
    term: 'Aktive Bauelemente',
    description: 'Können elektrische Signale vergrößern oder steuern. Beispiele: Elektronenröhren, Transistoren, Dioden und Thyristoren.'
  },
  {
    term: 'Akkumulator, Akku',
    description: 'Umgangssprachlich verwendeter Begriff für eine oder mehrere zusammengeschaltete galvanische Zellen (Sekundärzellen, wieder aufladbar).'
  },
  {
    term: 'Analogelektronik',
    description:
      'In der Analogtechnik werden kontinuierliche Signale verarbeitet. Ein typisches Beispiel ist ein analoger Verstärker oder die in einem älteren Röhrenfernseher eingesetzte Technik. Die dabei verarbeiteten Signale werden Analogsignale genannt.'
  },
  {
    term: 'Anode',
    description:
      'Elektrode, über die einem Bauteil Elektronen abgeführt werden. Beispiel: In einer Elektronenröhre wird ein Heizdraht durch Stromfluß zum Glühen gebracht. Der Heizdraht selber oder eine daran miterhitzte Elektrode (indirekt erhitzt) wird Kathode genannt. Durch die hohe Temperatur treten Elektronen aus der Kathode aus und bilden eine Elektronenwolke um die Kathode. Um die Heizwicklung herum ist eine meist zylinderförmige weitere Elektrode angebracht, die Anode. Sie hat die Funktion, die freien Ladungsträger wieder einzusammeln. Die Elektronen wandern von der Kathode zur Anode.'
  },
  {
    term: 'Antenne',
    description:
      'Dient dem Senden oder Empfangen elektromagnetischer Wellen. Wenn einer Antenne Hochfrequenzenergie zugeführt wird, dann werden elektromagnetische Wellen ausgestrahlt, wenn elektromagnetische Wellen auf die Antenne treffen, dann entstehen Hochfrequenzspannungen. Grundform einer Antenne ist ein Dipol. Antennen können bestimmte Richtdiagramme aufweisen (Rundstrahler, Richtstrahler) und für bestimmte Frequenzbereiche ausgelegt sein (Langwelle, Mittelwelle, UKW).'
  },
  {
    term: 'Audioverstärker',
    description:
      'Leistungsverstärker für den hörbaren Frequenzbereich. Bereitet schwache Audiosignale (Wechselspannung), z.B. eines UKW-Empfängers, so auf, dass sie verstärkt über Lautsprecher wiedergegeben werden können. Der Audioverstärker besteht mindestens aus einem Vorverstärker und einem Leistungsverstärker (Endstufe). Solche Verstärker wurden früher als Röhrenverstärker mit Elektronenröhren aufgebaut, heute kommen fast nur noch Transistoren bzw. integrierte Schaltkreise zum Einsatz.'
  },
  {
    term: 'Bananenbuchse',
    description:
      'Auch Bananensteckerbuchse oder Telefonbuchse oder Telefoneinbaubuchse genannt. Buchse für die weit verbreiteten Bananenstecker (Steckverbinder) für kleine Spannungen und Ströme. Die Buchse hat einen Durchmesser von 4mm. Bananenbuchsen werden neben Meßgeräten oft für Lautsprecher eingesetzt. Die Bananenbuchsen können vollständig außen isoliert sein. Sie besitzen in der Regel ein Gewinde und 1-2 Muttern für den Einbau in Frontplatten und Geräte. Neben dem Schraubanschluß haben diese Buchsen oft auch einen Lötanschluß und sind damit sehr vielseitig einsetzbar.'
  },
  {
    term: 'Bananenstecker',
    description:
      'Weit verbreiteter Steckverbinder für Versuchsaufbauten im Hobby- und Laborbereich für kleine Spannungen und Ströme. Die verwendeten Buchsen haben einen Durchmesser von 4mm. Der Bananenstecker besteht aus Blattfederelementen und hat einen isolierten Griff, in den oft Querlöcher eingearbeitet sind, in die ein weiterer Bananenstecker eingesteckt werden kann. Viele Meßgeräte wie Multimeter besitzen entsprechende Buchsen für diese Art Stecker.'
  },
  {
    term: 'Bandpaß',
    description:
      'Auch Bandpaßfilter genannter Filter, welcher Wechselspannungen und -ströme eines bestimmten Frequenzbereiches möglichst ungehindert durchläßt. Die Frequenzen oberhalb und unterhalb des Durchlaßbereiches werden dabei abgeschwächt (gedämpft) oder völlig gesperrt.'
  },
  {
    term: 'Basis',
    description:
      'Elektrode eines Transistors (Bipolartransistor). Dieser besteht aus drei wechselnden p- und n-dotierten Halbleiterschichten (Folge: npn bzw. pnp), welche eng beieinanderliegen und Kollektor, Basis und Emitter genannt werden. Die Basis liegt zwischen Kollektor und Emitter.'
  },
  {
    term: 'Basisschaltung',
    description:
      'Verstärkerschaltung eines Transistors, bei der die Eingangsspannung am pn-Übergang zwischen Basis und Emitter anliegt. Die Eingangsspannung wird am Emitter über einen Kondensator eingekoppelt. Die Ausgangsspannung wird durch den Kollektorstrom verursacht.'
  },
  {
    term: 'Batterie',
    description: 'Umgangssprachlich verwendeter Begriff für eine oder mehrere zusammengeschaltete galvanische Zellen (Primärzellen, nicht wieder aufladbar).'
  },
  {
    term: 'Betriebsspannung',
    description:
      'Die Betriebsspannung (in V) eines Gerätes oder einer Schaltung gibt an, wie hoch die Spannung sein muss, um das Gerät betreiben zu können. Viele Geräte haben eine Betriebsspannung von 230 Volt Wechselspannung, die übliche Netzspannung. Elektronikschaltungen, Spielzeuge, Taschenlampen oder Radios mit Batteriebetrieb haben dagegen eine Betriebsspannung im Bereich 1,5V - 9V Gleichspannung.'
  },
  {
    term: 'Blinker, Wechselblinker',
    description:
      'Elektronikschaltung mit 2 Transistoren, die astabiler Multivibrator, auch astabile Kippstufe, genannt wird. Die Schaltung kennt keinen stabilen Zustand, sondern schwingt zwischen zwei Zuständen hin und her. Die beiden Transistoren schalten und sperren sich abwechselnd gegenseitig.'
  },
  {
    term: 'Brückengleichrichterschaltung',
    description:
      'Gleichrichterschaltung aus zwei parallel geschalteten Diodenpaaren, auch Zweiweg-Gleichrichter genannt. Der Wechselspannungseingang befindet sich zwischen den Diodenpaaren. Als Ausgangsspannung entsteht eine pulsierende Gleichspannung, die wie beim Einweg-Gleichrichter durch den Kondensator mehr oder weniger geglättet werden kann. Sie wird auch Grätz-Schaltung genannt.'
  },
  {
    term: 'Darlington-Schaltung',
    description: 'Schaltung aus zwei Bipolartransistoren, bei der zwei Transistoren wie ein Transistor mit extrem hoher Stromverstärkung verwendet werden.'
  },
  {
    term: 'Dimmer-Schaltung',
    description:
      'Elektronische Schaltung mit Thyristoren oder Triacs, mit der sich die Leistungsaufnahme eines elektrischen Verbrauchers einstellen läßt. Wird u.a. zur Helligkeitseinstellung von Glühlampen eingesetzt.'
  },
  {
    term: 'Dämmerungsschalter',
    description:
      'Elektronikschaltung (Lichtsteuerschaltung) meist mit Fotowiderstand (LDR) und einer Verstärkerstufe (Transistor). Der elektrische Widerstand des LDR ändert sich mit dem Lichteinfall. Der Fotowiderstand ist im unbeleuchteten Zustand hochohmig, bei Lichteinfall wird er niederohmig. Die Lichtempfindlichkeit ist meist über einen Trimmer einstellbar.'
  },
  {
    term: 'Detektorradio',
    description:
      'Historische Rundfunk-Empfangstechnik, bei der ohne Stromquelle und Verstärker, nur mit Schwingkreisen und einem Kristalldetektor als Gleichrichter an einem Kopfhörer Rundfunk hören möglich war. Solch ein Detektorempfänger benötigte als Eingänge eine Antenne und einen Erdanschluss und besaß als Ausgang einen Kopfhöreranschluss.'
  },
  {
    term: 'Digitalelektronik',
    description:
      'In der Digitaltechnik werden diskrete Signale verarbeitet, die im einfachsten Fall aus den logischen Werten Null und Eins bestehen. Mittels Digitalelektronik lassen sich komplexe Logikschaltungen aufbauen. Beispiele sind Prozessoren im Computer oder Speicherbausteine.'
  },
  {
    term: 'Diode',
    description:
      'Die Diode als aktives Halbleiterbauelement besitzt zwei Anschlüsse. Sie wird durch einen p-n-übergang gebildet und zeichnet sich dadurch aus, dass Strom nur in einer Richtung fliessen kann, diese Richtung nennt man Durchlaßrichtung. Kehrt man die Richtung des Stromes aber um, dann bildet die Diode einen sehr hohen Widerstand, sie sperrt. Man spricht dann von der Sperrichtung.'
  },
  {
    term: 'Dipol (Antenne)',
    description:
      'Grundform einer Antenne. Geradliniger Leiter, dessen Länge gleich der halben Wellenlänge der zu sendenden (oder zu empfangenden) elektromagnetischen Welle oder einem ganzzahligen Vielfachen der halben Wellenlänge ist. Die HF-Energie wird in der Mitte eingespeist bzw. abgegriffen.'
  },
  {
    term: 'Einkristall',
    description:
      'Idealer Kristall, dessen Gitter in seiner gesamten Ausdehnung einen ungestörten Aufbau ohne mikroskopische Baufehler (Versetzungen, Fehlordnungen) hat. Einkristalle entstehen durch Kristallzüchtung aus einem Kristallisationskeim, der langsam aus der Schmelze des zu kristallisierenden Materials gezogen wird. Einkristalle (z.B. Silizium) werden in der Halbleiterindustrie benötigt, um Scheiben (Wafer) als Substrat für die Herstellung integrierter Schaltungen zu gewinnen.'
  },
  {
    term: 'Eintaktverstärker',
    description:
      'Verstärkerschaltung der Audioelektronik mit geringer Anzahl von Verstärkerstufen. Als Transistorverstärker-Schaltung haben sie nur einen Transistor. Für Endstufen früher meist in Röhrentechnik aufgebaut.'
  },
  {
    term: 'Elektroakustik',
    description:
      'Teilgebiet der Elektronik und technischen Akustik, welches sich mit der Umwandlung von Schall im hörbaren Bereich in elektrische Schwingungen und umgekehrt sowie mit der Speicherung, Wiedergabe und Erzeugung von Schall beschäftigt. Bauelemente der Elektroakustik sind Schallwandler wie z.B. Mikrofon und Lautsprecher, eine bekannte Elektronikschaltung ist der Tonfrequenzgenerator.'
  },
  {
    term: 'Elektrode',
    description:
      'Elektrischer Leiter, der den äußeren elektrischen Anschluß in ein spezielles Medium, wie z.B. Gas oder Flüssigkeit, realisiert. So ist die Elektronenröhre ein luftleerer Glaskolben, in den elektrische Anschlüsse über einen Sockel hineingeführt sind. Im Inneren der Röhre werden diese Anschlüsse dann Elektroden (Kathode und Anode) genannt.'
  },
  {
    term: 'Elektrodynamik',
    description:
      'Teilgebiet der Physik, welches sich mit elektrischen und magnetischen Feldern sowie bewegten elektrischen Ladungen und den dabei entstehende elektromagnetischen Wellen beschäftigt.'
  },
  {
    term: 'Elektrolytkondensator',
    description:
      'Bauform eines Kondensators (auch Elko genannt), der sich durch eine Polarität und eine relativ hohe Kapazität auszeichnet. Je nach verwendeten Materialien gibt es Aluminium-, Tantal-, oder Niob-Elektrolytkondensatoren.'
  },
  {
    term: 'Elektromagnet',
    description:
      'Eine stromdurchflossene Spule erzeugt ein Magnetfeld um sich. Die Feldlinien verlaufen parallel zur Spulenachse. Die einzelnen Feldlinien jeder Wicklung (die einzelnen Magnetfelder) überlagern sich und addieren sich. Es entsteht lokal ein viel stärkeres Magnetfeld, als es ein einzelner Leiter hätte erzeugen können. Ein Eisenkern verstärkt den Elektromagnet, die magnetischen Feldlinien treten am Ende des Eisenkerns aus und haben dort die größte Dichte außerhalb des Kerns.'
  },
  {
    term: 'Elektronenröhre',
    description:
      'Eine Elektronenröhre ist ein luftleerer Glaskolben, in den elektrische Anschlüsse über einen Sockel hineingeführt sind. Im Inneren der Röhre werden diese Anschlüsse dann "Elektroden" genannt. Ein Heizdraht wird durch Stromfluß zum Glühen gebracht, wie bei einer Glühlampe. Der Heizdraht selber oder eine daran miterhitzte Elektrode (indirekt erhitzt) wird Kathode genannt. Durch die hohe Temperatur treten Elektronen aus der Kathode aus und bilden eine "Elektronenwolke" um die Kathode. Sie stehen nun als freie Ladungsträger im Vakuum zur Verfügung. Um die Heizwicklung herum ist eine meist zylinderförmige weitere Elektrode angebracht, die Anode. Sie hat die Funktion, die freien Ladungsträger wieder "einzusammeln". Die Elektronen wandern von der Kathode zur Anode. Die Diode ist die einfachste Funktion, die sich mit einer Röhre herstellen läßt. An der Kathode wird eine negative Spannung und an der Anode eine positive Spannung angelegt. Die negativ geladenen Elektronen werden von der Anode angezogen, sie bewegen sich frei durch das Vakuum von der heißen Kathode zur Anode und werden dort wieder eingesammelt. Es fließt ein elektrischer Strom! Die Spannung wurde in "Flußrichtung" angelegt. Wenn zwischen Kathode und Anode ein Metallgitter eingebaut ist, welches ebenfalls als Elektrode fungiert, dann sprechen wir von einer Triode. Es gibt noch eine Vielzahl weiterer Röhrenarten, in denen weitere Metallgitter zum Einsatz kommen. So gibt es Tetroden (Vierelektrodenröhre - Kathode, Anode und 2 Gitter), Pentoden (Fünfelektrodenröhre - Kathode, Anode und 3 Gitter), Hexoden (Sechselektrodenröhre - Kathode, Anode und 4 Gitter) und weitere.'
  },
  {
    term: 'Emitter',
    description:
      'Elektrode eines Transistors (Bipolartransistor). Dieser besteht aus drei wechselnden p- und n-dotierten Halbleiterschichten (Folge: npn bzw. pnp), welche eng beieinanderliegen und Kollektor, Basis und Emitter genannt werden. Das Schaltsymbol des Transistors zeigt den Emitter (E) mit einem kleinen Pfeil.'
  },
  {
    term: 'Emitterschaltung',
    description:
      'Verstärkerschaltung eines Transistors, bei der die Eingangsspannung am pn-Übergang zwischen Basis und Emitter anliegt. Der Emitteranschluß ist der gemeinsame Bezugspunkt von Eingangs- und Ausgangsspannung.'
  },
  {
    term: 'Ferritkern',
    description: 'Kern für Hochfrequenzspulen aus Ferrit (spezielles Metall-Eisenoxid), welches ein magnetisches Verhalten wie Eisen besitzt, aber elektrischen Strom nicht leitet.'
  },
  {
    term: 'Filter',
    description:
      'Vierpol, der Wechselspannungen und -ströme eines bestimmten Frequenzbereiches dämpft (Sperrbereich) oder ungehindert passieren läßt (Durchlaßbereich). Ein solcher Filter wird meist aus einer Kombination von Spulen, Kondensatoren und Widerständen aufgebaut.'
  },
  {
    term: 'Flip-Flop-Schaltung',
    description:
      'Multivibratorschaltung nach dem Prinzip eines rückgekoppelten Verstärkers mit RC-Kopplung mit 2 Transistoren, die so geschaltet sind, dass abwechselnd jeweils im Ausgangskreis des einen Strom fließt, in demjenigen des anderen nicht. Die Flip-Flop-Schaltung (bistabiler Multivibrator) kippt bei Eintreffen eines Steuerimpulses in den jeweils entgegengesetzten Schaltzustand und verharrt in diesem, bis der nächste Impuls ihn zurückkippt. Er hat also 2 (bi) stabile Zustände.'
  },
  {
    term: 'Fotodiode, Fototransistor',
    description:
      'Halbleiterbauelemente, die den photoelektrischen Effekt nutzen und in Sperrichtung einen Sperrstrom nur fließen lassen, wenn Licht auf sie auftrifft. Fototransistoren haben meist nur zwei Anschlüsse - Kollektor und Emitter. Diese Bauelemente werden als Lichtdetektoren, z.B. in Lichtschranken oder Dämmerungsschaltern, eingesetzt.'
  },
  {
    term: 'Fotowiderstand',
    description:
      'Halbleiterbauelement, dessen Widerstand bei Bestrahlung mit sichtbarem (oder Infrarot oder UV-) Licht geringer wird. Als Halbleiterschicht werden Kadmiumsulfid, Bleisulfid oder Bleiselenid verwendet. Physikalisch beruht der Fotowiderstand auf dem inneren lichtelektrischen Effekt. Fotowiderstände werden in Signal- und Kontrolleinrichtungen wie Lichtschranken oder Dämmerungsschalter eingesetzt.'
  },
  {
    term: 'Fotozelle',
    description:
      'Bauelement, welches sichtbares, infrarotes (IR) oder ultraviolettes (UV) Licht in Strom bzw. Spannung umwandelt. Sie besteht aus einem evakuierten Glaskolben mit großflächiger Kathode und netz- oder ringförmiger Anode davor. Bei Lichteinfall emittiert die Kathode Elektronen, die zur positiven Anode fliegen - es fließt ein Fotostrom. Physikalisch beruht die Fotozelle auf dem äußeren lichtelektrischen Effekt.'
  },
  {
    term: 'Frequenzvervielfacher',
    description:
      'Baugruppe, mit der ganzzahlige Vielfache von Schwingungen einer gegebenen Frequenz gewonnen werden. Solche Frequenzvervielfacher werden in Sendern, Empfängern und Meßeinrichtungen eingesetzt.'
  },
  {
    term: 'Gatter',
    description: 'Oft benutzte Bezeichnung für eine logische Grundschaltung (auch Logikgatter), welche dann z.B. UND-Gatter, ODER-Gatter oder NICHT-Gatter genannt wird.'
  },
  {
    term: 'Gegentaktverstärker',
    description:
      'Verstärkerschaltung (Endstufenverstärker) mit zwei komplementären Transistoren (früher mit Elektronenröhren), die identische Gleichstromeigenschaften und identische, aber gegenläufige Arbeitskennlinien haben. Die beiden Transistoren werden jeweils mit einer Halbwelle des Eingangssignals angesteuert.'
  },
  {
    term: 'Gleichrichter',
    description:
      'Gerät oder Baustufe zur Umwandlung von Wechselstrom in Gleichstrom. Dazu werden Bauelemente mit einer Ventilwirkung verwendet, die dem Strom in einer Richtung einen hohen, in der anderen Richtung einen niedrigen elektrischen Widerstand entgegensetzen. Früher wurden dazu Röhrendioden eingesetzt, heute werden Halbleiterdioden oder Thyristoren eingesetzt. Es sind verschiedene Arten von Gleichrichterschaltungen möglich, u.a Einweggleichrichter, Zweiweggleichrichter, Graetz- oder Brückenschaltung.'
  },
  {
    term: 'Gleichspannung',
    description:
      'Die elektrische Spannung besitzt zwei Pole - den positiven Pluspol und den negativen Minuspol. Ändert eine Spannungsquelle ihre Polarität nicht, dann handelt es sich um eine Gleichspannungsquelle.'
  },
  {
    term: 'Gleichstrom',
    description:
      'Fließt von einer Gleichspannungsquelle ausgehend ein Strom, sprechen wir umgangssprachlich von Gleichstrom. Eine Batterie mit unveränderlichen Polen und eine parallel angeschlossene Glühlampe lassen einen einfachen Stromkreis mit Gleichstromfluß entstehen. Weitere Beispiele für eine Gleichspannungsquelle sind eine Solarzelle, eine Autobatterie oder der Akku im Handy.'
  },
  {
    term: 'Gleichstromgenerator',
    description:
      'Auch Dynamo genannt, wandelt mechanische Energie in elektrische Energie durch Induktion um. An Schleifkontakten zum Abgriff der Spannung erfolgt nach einer halben Umdrehung eine Umpolung, sodass der Rotor eine pulsierende Gleichspannung abgibt.'
  },
  {
    term: 'Glühlampe',
    description:
      'Evakuierter Glaskolben mit einem Leuchtdraht im Inneren. Der Draht wird durch elektrischen Stromfluß auf eine hohe Temperatur erhitzt, bis er glüht. Hierfür wird das Metall Wolfram verwendet, welches erst bei sehr hohen Temperaturen (oberhalb von 3000°C) schmilzt. Durch die hohe Temperatur sendet der Glühfaden neben einer großen Portion Wärmestrahlung eben auch Licht aus. Der Wirkungsgrad ist dabei sehr gering, da ein hoher Anteil an Wärme mit entsteht.'
  },
  {
    term: 'Grundschaltungen des Transistors',
    description:
      'Grundschaltungen des Transistors sind meist Verstärkerschaltungen und werden Kollektorschaltung, Emitterschaltung und Basisschaltung genannt. Der Eingang ist immer die Basis-Emitter-Strecke.'
  },
  {
    term: 'Halbleiter',
    description:
      'Chemische Elemente oder Verbindungen, deren elektrische Eigenschaften stark von der Temperatur und eingelagerten Fremdatomen abhängen. Bekannte Halbleiter sind Germanium, Silizium, Selen und Bleisulfid. Der Einbau von Fremdatomen in kristallinen Halbleitern (Dotierung) erlaubt den Aufbau elektronischer Bauelemente wie Dioden und Transistoren.'
  },
  {
    term: 'Heißleiter',
    description:
      'Temperaturabhängige Halbleiterwiderstände mit stark negativem Temperaturkoeffizienten. Je höher die Temperatur, desto niedriger wird ihr Widerstand. Sie werden auch NTC-Widerstände genannt (NTC = Negative Temperature Coefficient). Meist aus Metalloxiden gefertigt. Sie werden als Temperatursensoren eingesetzt.'
  },
  {
    term: 'Hochfrequenzlitze',
    description:
      'Auch HF-Litze genannt, besteht aus feinen, isolierten Drähten, die verflochten sind. Bei Wechselströmen mit hohen Frequenzen wird ein großer Teil des Stromes an der Oberfläche eines Leiters transportiert (Skin-Effekt). Durch die große Anzahl einzelner Drähte wird die Oberfläche der Litze vergrößert.'
  },
  {
    term: 'Hupe',
    description:
      'Elektromechanisch arbeitender akustischer Signalgeber mit elastischer Stahlmembran, welche als Unterbrecher arbeitet und so in Schwingungen versetzt wird. Dadurch wird die davor befindliche Luft ebenfalls in Schwingungen versetzt, welcher akustisch als Schall wahrgenommen wird.'
  },
  {
    term: 'Impedanz',
    description: 'Komplexe Größe, die aus dem Wechselspannungswiderstand und dem ohmschen Widerstand gebildet wird, auch Wechselstromwiderstand genannt.'
  },
  {
    term: 'Induktion',
    description:
      'Elektrische und magnetische Vorgänge besitzen einen engen Zusammenhang. Ein Magnetfeld kann in einer Spule einen elektrischen Strom erzeugen. Das Induktionsgesetz besagt, dass die induzierte Spannung gleich der Änderungsgeschwindigkeit des magnetischen Flußes ist. Ursache dieser Induktion ist die Tatsache, dass ein veränderliches Magnetfeld eine Ladungstrennung im elektrischen Leiter bewirkt (Lorenzkraft) und damit eine Spannung im Leiter entstehen läßt.'
  },
  {
    term: 'Integrierter Schaltkreis',
    description:
      'Ein Integrierter Schaltkreis (IS, auch IC - Integrated Circuit, Integrierte Schaltung, Chip genannt) ist Baustein, der analoge oder digitale Signale verarbeitet und dessen Bauelemente und Leitungsverbindungen in einer gemeinsamen Folge von Prozeßschritten hergestellt werden und nicht austauschbar sind. Sie werden durch ein Keramik- oder Kunststoffgehäuse hermetisch abgeschlossen. Integrierte Schaltungen wurden durch die technologische Entwicklung der Mikroelektronik ermöglicht und zeichnen sich seit Jahrzehnten durch eine fortschreitende Miniaturisierung aus.'
  },
  {
    term: 'Isolator',
    description:
      'Stoff mit geringer elektrischer Leitfähigkeit. In der Elektrotechnik wird damit ein Bauteil bezeichnet, welches den Stromfluß zwischen elektrischen Leitern verhindert. Beispiele für Isolatormaterialien sind Glas, Marmor, Porzellan und Bernstein'
  },
  {
    term: 'Kathode',
    description:
      'Elektrode, über die einem Bauteil Elektronen zugeführt werden. Beispiel: In einer Elektronenröhre wird ein Heizdraht durch Stromfluß zum Glühen gebracht. Der Heizdraht selber oder eine daran miterhitzte Elektrode (indirekt erhitzt) wird Kathode genannt. Durch die hohe Temperatur treten Elektronen aus der Kathode aus und bilden eine Elektronenwolke um die Kathode.'
  },
  {
    term: 'Klangregelung',
    description:
      'Wählbare Beeinflussung des Frequenzgangs einer elektroakustischen Wiedergabeanlage. Wird erreicht durch Abschwächen oder Anheben bestimmter Teile des übertragenen Frequenzbandes. Das Ziel der Klangregelung ist die Anpassung des Klanges an das subjektive Empfinden des Zuhörers. Oft werden dabei getrennte Regler für die Höhen- und Tiefenanhebung (Höhen- und Tiefenregler) genutzt, die elektronische Filterschaltungen einsetzen. Moderne Anlagen verfügen über die Möglichkeit, mehrere Frequenzbereiche getrennt voneinander zu beinflussen (Equalizer).'
  },
  {
    term: 'Koaxialkabel',
    description:
      'Konzentrisch aufgebaute Kabel für den Einsatz in der Hochfrequenztechnik. Bestehen aus Innenleiter (auch Seele genannt, meist aus Kupfer), Dielektrikum (meist aus Kunststoff gefertigte Isolationsschicht), Schirmung (elektrisch leitende Ummantelung) und Kabelmantel.'
  },
  {
    term: 'Kollektor',
    description:
      'Elektrode eines Transistors (Bipolartransistor). Dieser besteht aus drei wechselnden p- und n-dotierten Halbleiterschichten (Folge: npn bzw. pnp), welche eng beieinanderliegen und Kollektor, Basis und Emitter genannt werden. Der Kollektor wird in Schaltsymbolen oft auch mit C bezeichnet.'
  },
  {
    term: 'Kollektorschaltung',
    description:
      'Verstärkerschaltung eines Transistors, bei der die Eingangsspannung am pn-Übergang zwischen Basis und Emitter anliegt. Der Kollektor wird direkt mit dem Pluspol der Spannungsquelle verbunden und liegt damit auf einem Massepotenzial für Wechselspannungen.'
  },
  {
    term: 'Kondensator',
    description:
      'Ein Kondensator ist ein einfaches elektrisches (passives) Bauelement, welches in der Lage ist, elektrische Ladungen zu speichern. Ein einfacher Kondensator besteht aus 2 Metallplatten, die sich sehr dicht gegenüber stehen, sich aber nicht berühren dürfen. Je größer die Platten und je kleiner der Abstand zwischen ihnen ist, desto mehr elektrische Ladungen kann ein Kondensator aufnehmen. Die Ladung, die der Kondensator aufnehmen kann, hängt von der verwendeten Spannung und der Kapazität des Kondensators ab. Das Formelzeichen für die Kapazität ist ein C, die Maßeinheit für die Kapazität ist das Farad, abgekürzt F. Das Schaltzeichen eines Kondensators symbolisiert übrigens die zwei sich gegenüber stehenden Metallplatten.'
  },
  {
    term: 'Krokodilklemme, Krokoklemme',
    description:
      'Anschlußklemme in der Elektrotechnik, die ohne löten oder schrauben schnelle Versuchsaufbauten erlaubt, indem das zu kontaktierende Bauteil durch zwei Zahnreihen umschlossen wird. Das Aussehen der Klemme ähnelt dem eines Krokodils, woher sich der Name ableitet. Krokodilklemmen gibt es in verschiedenen Ausführungen, sehr bekannt ist die Variante, die das Einstecken eines Bananensteckers (4-mm-Federstecker) erlaubt.'
  },
  {
    term: 'Lautsprecher',
    description:
      'Schallwandler zur Umwandlung niederfrequenter Wechselströme in Schallschwingungen, bestehend aus Gehäuse, Magnet, Spule und einer Membran. Der Magnet ist ein Dauermagnet (Permanentmagnet), der die Form eines Topfes hat. Die Membran besteht aus einem Spezialpapier und ist konusförmig. Sie ist außen am Gehäuse befestigt, kann aber innen frei schwingen. Am Konusende trägt sie eine Spule (Schwingspule), die in den ringförmigen Luftspalt des Magneten eintaucht. Fließt nun niederfrequenter Wechselstrom durch die Spule, dann wird die Spule vom Magneten abwechselnd angezogen und abgestoßen. Die Membran, die mit der Spule verbunden ist, übernimmt die Bewegungen der Spule und überträgt ihre Schwingungen an die umgebende Luft und erzeugt so Schallwellen.'
  },
  {
    term: 'Leiter',
    description:
      'In der Elektrotechnik werden Stoffe als Leiter bezeichnet, die geladene Teilchen transportieren können. Sie besitzen eine elektrische Leitfähigkeit mit niedrigem elektrischem Widerstand. Typische Beispiel sind Metalle wie Kupfer, Aluminium oder Silber.'
  },
  {
    term: 'Lenzsche Regel',
    description:
      'Elektrizität und Magnetismus haben einen engen Zusammenhang. Fließt ein elektrischer Strom, so entsteht auch ein Magnetfeld. Bewegte Magnete erzeugen eine elektrische Wirkung in einem elektrischen Leiter. Diesen letzteren Vorgang nennt man Induktion. Induzierte Spannungen, Ströme und Kräfte haben dabei immer eine solche Richtung, dass sie ihre Ursache hemmen.'
  },
  {
    term: 'Leuchtdiode (LED)',
    description:
      'Eine Leuchtdiode (Licht emittierende Diode - LED) erzeugt Licht, wenn sie in Durchlaßrichtung betrieben wird. Sie besteht als Halbleiterbauelement aus einem Halbleiterübergang und zeichnet sich durch einen hohen Wirkungsgrad aus. LEDs müssen immer mit einem Vorwiderstand betrieben werden.'
  },
  {
    term: 'Logikschaltung',
    description:
      'Binäre Schaltanordnungen zur technischen Realisierung von Beziehungen und Verknüpfungen der Schaltungsalgebra. Die Signale L (low) und H (high) werden durch Spannungswerte dargestellt. L entspricht dabei 0V. Elementare Logikschaltungen (Grundschaltungen) können die Rechenoperationen NICHT, UND, ODER sowie ENTWEDER-ODER umsetzen und werden Gatter genannt.'
  },
  {
    term: 'Lötauge',
    description:
      'Meist runder Kupferbelag rund um ein Bohrloch einer Platine (Leiterplatte), welches zum Kontaktieren der Bauelemente (Löten) dient. Von den Lötaugen ausgehend führen die Leiterbahnen zu den nächsten Bauelementen.'
  },
  {
    term: 'Luftspule',
    description:
      'Spule ohne einen magnetischen Kern, wird buchstäblich in die Luft gewickelt. Wird bei Hochfrequenzanwendungen benötigt (z.B als Drosselspule oder Filter). Luftspulen können verschiedene Bauformen haben: z.B. zylindrisch, rechteckig oder flach.'
  },
  {
    term: 'Magnetspule',
    description: 'Siehe Spule'
  },
  {
    term: 'Microcontroller',
    description: 'Integrierter Schaltkreis (Chip), der neben einem Prozessor zusätzliche Bausteine wie Speicher, Ein- und Ausgänge sowie Schnittstellen enthält.'
  },
  {
    term: 'Morsetaste',
    description:
      'Dient dem erleichterten Tasten von Morsezeichen. Die Taste, mit der die Signale erzeugt werden, ist ein Bedienelement, welches nur solange Strom fließen läßt, wie man sie gedrückt hält. Das unterscheidet eine Taste von einem Schalter, welcher nach dem Schaltvorgang seinen Zustand dauerhaft beibehält. Die Morsetaste besteht aus einer Grundplatte, einem Gehäuse, einem Tastenhebel, einem Tastenknopf, einem Tastenkontakt und einer Tastenfeder mit jeweils einer Stellschraube. Außerdem führen Anschlußkabel nach außen und enden in einem speziellen Stecker.'
  },
  {
    term: 'Multimeter',
    description:
      'Meßgerät in der Elektrotechnik und Elektronik, welches verschiedene Meßgrößen wie Strom, Spannung oder Widerstand in unterschiedlichen Meßbereichen und bei unterschiedlichen Arten von Strom (Gleich- oder Wechselstrom) messen kann. Wird auch Vielfachmeßgerät genannt. Während früher meist analoge Drehspulmeßgeräte mit Zeigern dominierten, werden heute fast nur noch digitale Geräte eingesetzt. Einige Geräte bieten auch die Möglichkeit, elektronische Bauelemente wie Transistoren und Dioden, zu testen.'
  },
  {
    term: 'Netzteil',
    description:
      'Baugruppe zur Stromversorgung elektronischer Geräte aus dem Energienetz. Besteht meist aus Netztransformator, Gleichrichter und Siebketten und kann zusätzlich eine Spannungsstabilisierung enthalten.'
  },
  {
    term: 'Nichtleiter',
    description:
      'In der Elektrotechnik werden Stoffe als Nichtleiter bezeichnet, die keine geladenen Teilchen transportieren können. Sie besitzen keine elektrische Leitfähigkeit und haben einen hohen elektrischen Widerstand. Sie werden in der Technik als Isolatoren eingesetzt. Typische Beispiele sind viele Kunststoffe, Glas oder Keramik.'
  },
  {
    term: 'NICHT-Schaltung',
    description:
      'Logikschaltung, die die mathematische Operation NICHT umsetzt. Realisiert wird dies, indem die Funktion eines Schalters umgekehrt (invertiert) wird: Ist ein Schalter nicht geschlossen, so fließt Strom durch den Stromkreis.'
  },
  {
    term: 'ODER-Schaltung',
    description:
      'Logikschaltung, die die mathematische Operation ODER umsetzt. Realisiert wird dies, indem zwei Schalter parallel geschaltet werden. Wenn Schalter 1 ODER Schalter 2 (ODER beide) geschlossen sind, kann Strom durch den Stromkreis fließen.'
  },
  {
    term: 'Operationsverstärker',
    description:
      'Ein mehrstufiger, elektronischer Verstärker für Gleichspannungen und Wechselspannungen. Der ideale Operationsverstärker hat einen unendlich großen Verstärkungsfaktor. Er hat einen invertierenden Eingang und einen nicht-invertierenden Eingang. Als Differenzverstärker verstärkt er die Differenz zwischen den beiden Eingängen. Einsatzgebiete sind Impedanzwandler, invertierender Verstärker, Strom-Spannungswandler, Differenzverstärker, Differenzierer (Hochpaß), Integrierer (Tiefpaß).'
  },
  {
    term: 'Parallelschaltung',
    description:
      'Wenn elektrische Bauelemente so miteinander verbunden sind, dass die Anschlüsse aller Bauelemente jeweils direkt mit der Spannungsquelle (z.B. einer Batterie) elektrisch kontaktiert sind, dann entstehen mehrere getrennte Stromkreise. Eine solche Schaltung nennt man Parallelschaltung, alle teilnehmenden Bauelemente werden parallel, gleichzeitig von der Spannungsquelle versorgt. Der Strom teilt sich auf alle Bauelemente auf, die Teilströme hängen von den Widerständen der einzelnen Bauelemente ab. Je mehr Bauelemente parallel geschaltet werden, desto größer wird der Gesamtstrom, der fließt. Fällt ein Bauelement aus (z.B. eine Glühbirne ist defekt), dann werden alle anderen Bauelement weiterhin mit Strom versorgt.'
  },
  {
    term: 'Passive Bauelemente',
    description: 'Haben keine Verstärker- oder Steuerungsfunktion. Beispiele: Widerstände, Kondensatoren und Induktivitäten (Spulen), aber auch Lämpchen, Summer und Mikrofone.'
  },
  {
    term: 'Platine',
    description:
      'Eine Platine (sie wird auch Leiterplatte, gedruckte Schaltung oder Leiterkarte genannt) dient dazu, die verschiedenen Bauteile einer elektronischen Schaltung (Transistoren, Schaltkreise, Widerstände, Kondensatoren oder Spulen) zu befestigen und sie gleichzeitig elektrisch, entsprechend der Schaltung, zu verbinden. Sie besteht aus einem elektrisch isolierenden Trägermaterial und darauf haftenden Leiterbahnen aus Kupfer, die die Bauelemente elektrisch verbinden.'
  },
  {
    term: 'Reibungselektrizität',
    description:
      'Elektrische Aufladung (Entstehen elektrischer Spannung) durch Aneinanderreiben zweier Isolatoren. Entsteht z.B. beim Reiben eines Luftballons oder eines Kunststoffstabes an Wolle.'
  },
  {
    term: 'Reihenschaltung',
    description:
      'Wenn elektrische Bauelemente so miteinander verbunden sind, dass der Anschluss eines Bauelements jeweils mit dem Anschluß des nächsten elektrisch verbunden ist usw., dann entsteht durch deren Hintereinanderschalten ein geschlossener Stromkreis. Eine solche Schaltung nennt man Reihenschaltung (auch Serienschaltung), alle teilnehmenden Bauelemente werden der Reihe nach vom gleichen Strom durchflossen. Der Strom in der Reihenschaltung ist an allen Stellen stets gleich groß. Fällt ein Bauelement aus (z.B. eine Glühbirne ist defekt), dann wird der Stromfluß überall unterbrochen.'
  },
  {
    term: 'Relais',
    description:
      'Ein Relais öffnet und schließt elektrische Kontakte durch ein Magnetsystem. Bei Anlegen einer Spannung an eine Spule (Steuerspannung) fließt Strom, wodurch ein Magnetfeld erzeugt wird, welches einen beweglichen Anker anzieht, der wahlweise Kontakte öffnen oder schließen kann. Nach dem Abschalten der Steuerspannung zieht eine Feder den Anker in die Ausgangslage zurück.'
  },
  {
    term: 'Röhrenverstärker',
    description:
      'Ein elektronischer Verstärker für niederfrequente elektrische Signale, der mit Elektronenröhren als aktive (verstärkende) elektronische Bauelemente aufgebaut ist. Wurde vor dem Einsatz der Halbleiterelektronik als Audioverstärker genutzt.'
  },
  {
    term: 'Schalter',
    description:
      'Dienen zum Herstellen einer elektrisch leitenden Verbindung zwischen einem festem und einem beweglichen Kontakt, der meist mechanisch betätigt wird. Es gibt viele Bauformen, z.B. Kippschalter, Wippschalter und Schiebeschalter. Es gibt aber auch Drehschalter (früher in Haushalten als Lichtschalter üblich) oder Fußschalter (z.B. bei einer elektrischen Nähmaschine). Ihnen gemeinsam ist, dass sie betätigt werden müssen, um den Schaltzustand zu ändern. Dazu ist die Einwirkung einer Kraft nötig.'
  },
  {
    term: 'Schaltnetzteil',
    description:
      'Elektronische Baugruppe, die Wechselspannung gleichrichtet, über einen Kondensator speichert und pulsartig Strom auf einen relativ kleinen Transformator gibt. Die Gleichspannung wird dadurch zu Wechselspannung, die in dem Transformator transformiert wird. Die transformierte Spannung wird wieder gleichgerichtet, über Kondensatoren gesiebt und dann stabilisiert'
  },
  {
    term: 'Schaltplan',
    description:
      'Grafische Darstellung einer elektrischen Schaltung (auch Schaltbild oder Schaltskizze genannt) mit grafischen Symbolen der Bauelemente (Schaltzeichen). In der Elektrotechnik wird der Schaltplan auch Stromlaufplan genannt. Er stellt mit grafischen Symbolen den Fluß des elektrischen Stroms dar. Eine geschlossene Linie von einem Schaltzeichen zum nächsten symbolisiert eine elektrische Verbindung (Leitung). Dabei ist es egal, ob diese Verbindungen durch einen Schaltdraht, eine Kupferlitze oder ein Stück Blech realisiert sind. Die Linie ist, ebenso wie die Schaltzeichen, ein Symbol.'
  },
  {
    term: 'Schaltzeichen',
    description: 'Grafische Symbole elektrischer und elektronischer Bauelemente.'
  },
  {
    term: 'Schottky-Diode',
    description:
      'Halbleiterbauelement mit einem Metall-Halbleiter-Kontakt, welches sehr schnell von Sperrichtung in Durchlaßrichtung (und umgekehrt) umschalten kann. Daher eignen sich Schottky-Dioden besonders für Anwendungen in der Hochfrequenztechnik.'
  },
  {
    term: 'Schwingkreis',
    description:
      'Auch Schwingungskreis oder Resonanzkreis genannt. Anordnung aus Spule und Kondensator, in der elektromagnetische Schwingungen erregt werden können. Wenn ein Kondensator über eine Spule entladen wird, dann baut die Spule während des Stromflusses ein Magnetfeld auf. Der Kondensator entlädt sich. Ist der Kondensator entladen, dann bricht das Magnetfeld zusammen. Dabei wird in der Spule eine Spannung induziert, die den Kondensator mit umgekehrter Polarität wieder auflädt. Dieser Vorgang wiederholt sich. Das elektrische Feld im Kondensator und das magnetische Feld der Spule wechseln periodisch, es fließt Wechselstrom.'
  },
  {
    term: 'Schwingspule',
    description: 'Siehe Lautsprecher'
  },
  {
    term: 'Serienschaltung',
    description: 'Siehe Reihenschaltung'
  },
  {
    term: 'Selbstinduktion',
    description:
      'Wird eine Spule von einem Strom durchflossen, so entsteht ein Magnetfeld (Elektromagnet). Umgekehrt erzeugt ein veränderliches Magnetfeld eine Ladungstrennung im elektrischen Leiter (Lorenzkraft) und läßt damit eine Spannung im Leiter entstehen (Elektromagnetische Induktion). Ändert sich der Stromfluß durch eine Spule, so bewirkt dies eine Änderung des magnetischen Flusses durch die Spule selbst, was sofort eine Spannung in der gleichen Spule induziert (Selbstinduktion). Nach der Lenzschen Regel ist der dabei induzierte Strom in einem Stromkreis so gerichtet, dass er der Ursache seiner Entstehung entgegen wirkt.'
  },
  {
    term: 'Sicherung',
    description:
      'Unterbricht einen Stromkreis, wenn eine bestimmte, festgelegte Stromstärke für einen bestimmten Zeitraum überschritten wird. Solch eine Unterbrechung kann notwendig sein, wenn Bauelemente ausfallen oder durch eine Fehlschaltung ein Kurzschluß entstanden ist. In diesem Fall würde ein sehr hoher Kurzschlußstrom fließen und Bauelemente oder Leiter könnten sich unzulässig erwärmen. In älteren Hausinstallationen findet man noch Schmelzsicherungen mit Porzellankörper, üblicherweise werden heute moderne Leitungsschutzschalter eingesetzt.'
  },
  {
    term: 'Solarzelle',
    description:
      'Bauelement, welches Licht- und Wärmestrahlung direkt in elektrische Energie umwandeln kann. Wird in der Photovoltaik genutzt, um Energie aus Sonnenlicht zu gewinnen. Solarzellen werden meist aus dem Halbleiter Silizium hergestellt. Leider können Solarzellen nur einen Teil der einfallenden Sonnenenergie in elektrische Energie umwandeln. Man spricht hier auch vom Wirkungsgrad. Dieser Wirkungsgrad gibt an, wieviel Prozent des einfallenden Sonnenlichtes tatsächlich in elektrische Energie gewandelt wird. Durch intensive Forschung und Entwicklung werden immer bessere Solarzellen gebaut werden können.'
  },
  {
    term: 'Spannung, elektrische',
    description:
      'Elektrischer Strom entsteht durch bewegte Ladungsträger, sie können sowohl negative Ladung (Elektronen) als auch positive (Ionen) haben. In einem Metall sind die Elektronen frei beweglich. Sie werden bewegt, weil ein elektrisches Feld sie antreibt. Das elektrische Feld ist also der Motor unserer Elektronen. Haben wir an einem Punkt viele positive Ladungen, dann wirkt deren elektrisches Feld anziehend auf die Elektronen, sie wollen zu den positiven Ladungen wandern. Je mehr positive Ladungen dort sind, desto stärker ist die Kraft, die die Elektronen treibt. Für die Anzahl der elektrischen Ladungen hat man ein Maß definiert, es ist die elektrische Spannung. Sie gibt einfach an, wie groß der Unterschied der elektrischen Ladungen zwischen zwei Punkten ist. Sie wird in Volt gemessen, abgekürzt V.'
  },
  {
    term: 'Spannungsmessung',
    description:
      'Bestimmung der Differenz der elektrischen Ladung zwischen zwei Polen (Potentialdifferenz). Die elektrische Spannung als Meßgröße wird in Volt (V) gemessen. Dazu werden Spannungsmeßgeräte verwendet, die sowohl analog (Drehspulmeßgerät) als auch digital (Multimeter) arbeiten können. Das Meßgerät sollte dabei einen möglichst hohen elektrischen Widerstand besitzen.'
  },
  {
    term: 'Spannungsregler',
    description:
      'Elektronische Schaltung zur Stabilisierung der Versorgungsspannung elektrischer oder elektronischer Baugruppen. Schwankende Versorgungsspannungen entstehen z.B. durch Nachlassen der Leistung eines Akkus oder durch erlaubte Schwankungen der Netzspannung. Es können sowohl Gleich- als auch Wechselspannungen stabilisiert werden.'
  },
  {
    term: 'Spannungsteiler',
    description:
      'Anordnung aus mehreren Widerständen, mit der aus einer Spannung mehrere Teilspannungen gewonnen werden können. Für Gleichspannungen werden Ohmsche Widerstände benutzt, für Wechselspannungen auch kapazitive oder induktive Widerstände.'
  },
  {
    term: 'Spule',
    description:
      'Mehrere parallele und gegeneinander isolierte Drahtwindungen (Wicklungen), die in gleichem Sinne von Strom durchflossen werden, bilden eine Spule (auch Magnetspule genannt). Spulen werden in Transformatoren, Elektromagneten oder Relais eingesetzt. Wichtigste Kenngröße ist ihre Induktivität.'
  },
  {
    term: 'Steckbrett',
    description:
      'Auch Steckplatine oder Breadboard genannt. Erlaubt den Aufbau experimenteller Schaltungen und Versuche (Prototypen). Die Bauelementanschlüsse werden nicht gelötet, sondern in Löcher mit Kontaktfedern gesteckt.'
  },
  {
    term: 'Strom, elektrischer',
    description:
      'Bewegung von Ladungsträgern, sie können sowohl negative Ladung (Elektronen) als auch positive (Ionen) haben. Die Einheit für die elektrische Stromstärke ist Ampere, abgekürzt A. Die technische Stromrichtung ist nicht identisch mit der Richtung der Elektronenbewegung.'
  },
  {
    term: 'Stromkreis',
    description:
      'Stromkreise dienen dazu, elektrische Energie zu übertragen, welche in der Energiequelle (z.B. einer Batterie) gewonnen wird und in einem Verbraucher (z.B. einem Elektromotor, einer Glühbirne,...) in eine andere Energieform (Wärme, Magnetfeld) umgewandelt wird. Ein Stromkreis ist entweder geschlossen (es fließt Strom) oder offen (der Stromfluß ist unterbrochen).'
  },
  {
    term: 'Strommessung',
    description:
      'Bestimmung der elektrischen Stromstärke in einem Stromkreis bzw. in einer elektronischen Schaltung. Erfolgt mit dem Stromstärkemesser (Amperemeter), welches üblicherweise in einem Mehrfachmeßgerät (Multimeter) integriert ist. Die Einheit der Stromstärke ist das Ampere, abgekürzt A. Der zu messende Strom muß in einer Reihenschaltung durch das Meßgerät fließen. Früher wurden zur Strommessung Drehspulmeßgeräte eingesetzt (analoge Messung), heutige Multimeter arbeiten digital (Digitalmultimeter).'
  },
  {
    term: 'Summer',
    description:
      'Ein Summer ist ein elektroakustischer Signalgeber, der entweder elektromagnetisch oder piezoelektrisch betrieben wird. Er erzeugt einen Piep-, Summ- oder Brummton und wird in Alarmanlagen oder Geräten eingesetzt, in denen akustische Signale besser als optische wahrgenommen werden.'
  },
  {
    term: 'Taster',
    description:
      'Art eines Schalters, die nach der Betätigung in ihren Ausgangszustand, ihre Ruhestellung, zurückkehrt. Es wird nur solange eine elektrische Verbindung hergestellt, wie der Taster betätigt wird. Dafür sorgt eine mechanische Feder, die das Bedienelement und den Kontakt in die Ruhelage zurückführt. Es hat sich im allgemeinen Sprachbereich eingebürgert, zwischen Schaltern und Tastern zu unterscheiden. Es gibt Taster, die bei Betätigen einen Kontakt schließen (Schließer) und solche, die bei Betätigen einen Kontakt öffnen (öffner). Die klassische Morsetaste ist z.B. ein Schließer, ebenso die Tasten einer Computermaus.'
  },
  {
    term: 'Thermo-Bimetall',
    description:
      'Bimetall besteht aus zwei Metallen mit unterschiedlichen Ausdehnungskoeffizienten. Die beiden Metalle sind fest miteinander verbunden. Wird nun die Temperatur des Bimetallstreifens durch Wärmezufuhr geändert, so dehnt sich eines der beiden Metalle stärker aus als der andere. Da sie miteinander verbunden sind, kommt es zu einer Verbiegung des Stückes Bimetall. Dies läßt sich ausnutzen, um einen Schaltvorgang auszulösen (Feuermelder).'
  },
  {
    term: 'Thermoelement',
    description:
      'Läßt eine Gleichspannung an der Verbindungsstelle zweier verschiedener metallischer Leiter entstehen, wenn entlang der Leiter eine Temperaturdifferenz existiert. Beruht auf dem Seebeck-Effekt. Die entstehende Spannung wird Thermospannung genannt und kann zur Temperaturmessung genutzt werden.'
  },
  {
    term: 'Thyristor',
    description:
      'Aktives Halbleiterbauelement, welches als Hochstromschalter (Leistungsschalter) eingesetzt wird. Der Name wurde durch die Begriffe Thyratron und Transistor gebildet. Die Anschlüsse heißen Anode, Kathode und Gate. Ein Thyristor besitzt zwei stabile Zustände, von denen einer hochohmig und der andere niederohmig ist. Über einen Steueranschluß (Gate-Elektrode) erfolgt das Umschalten vom hochohmigen auf den niederohmigen Zustand.'
  },
  {
    term: 'Tonfrequenzgenerator',
    description:
      'Wechselspannungsquelle für die Schwingungserzeugung im niederfrequenten Bereich (Tonfrequenz im hörbaren Bereich). Wird für Prüf- und Meßzwecke (z.B. Verstärker, Lautsprecher) genutzt. Die sinusförmige Spannung läßt sich meist in Frequenz und Amplitude wählbar einstellen.'
  },
  {
    term: 'Transistor',
    description:
      'Steuerbares aktives Halbleiterbauelement (meist mit 3 Anschlüssen - Emitter, Basis, Kollektor). [von engl. transfer + resistor]. Er stellt einen steuerbaren elektrischen Widerstand dar. Es gibt bipolare und unipolare Transistoren (Feldeffektransistor) sowie spezielle Bauformen. Historisch löste der Transistor zunächst die Elektronenröhre als Verstärker ab und wurde später das Herzstück moderner elektronischer Schaltkreise, in denen er als Schalter eingesetzt wird. Ausgangsmaterial zur Herstellung ist heute meist Silizium, für spezielle Anwendungen auch Galliumarsenid.'
  },
  {
    term: 'Transformator',
    description:
      'Elektrotechnisches Bauelement (auch Übertrager genannt), welches durch elektromagnetische Induktion Wechselspannung bzw. Wechselstrom umformt. Er besteht aus mindestens 2 getrennten Wicklungen, die durch ein gemeinsames Magnetfeld verknüpft sind. Die Wicklung, der der umzuformende Strom bzw. die Spannung zugeführt wird, heißt Primärwicklung. Der transformierte Strom bzw. die transformierte Spannung wird an der Sekundärwicklung abgenommen.'
  },
  {
    term: 'Triac',
    description:
      'Aktives Halbleiterbauelement der Schichtfolge n-p-n-p-n zur Steuerung und Regelung von Wechselströmen. Auch Zweiwegthyristor genannt. Entspricht 2 Thyristoren in Antiparallelschaltung.'
  },
  {
    term: 'Trigger',
    description: 'Schaltung, die zur Steuerung weiterer Baustufen auslösende Impulse bestimmter Frequenz und Form abgibt.'
  },
  {
    term: 'Triode',
    description:
      'Elektronenröhre mit 3 Elektroden - Anode, Kathode und Steuergitter. Die Kathode wird direkt oder indirekt geheizt und emittiert Elektronen, welche von der Anode aufgenommen werden (Anodenstrom). Dieser Strom läßt sich durch eine am Steuergitter angelegte Spannung beinflussen und sogar verstärken. Die Triode wird bevorzugt als Verstärkerbauelement eingesetzt.  '
  },
  {
    term: 'Tunneldiode',
    description: 'Halbleiterdiode mit hoch dotierten p- und n-Bereichen und dadurch sehr schmaler Sperrzone für den Einsatz in der Hochfrequenz-Technik.'
  },
  {
    term: 'UND-Schaltung',
    description:
      'Logikschaltung, die die mathematische Operation UND umsetzt. Realisiert wird dies, indem zwei Schalter in Reihe geschaltet werden. Nur wenn Schalter 1 UND Schalter 2 geschlossen sind, kann Strom durch den Stromkreis fließen.'
  },
  {
    term: 'Verstärker',
    description:
      'Ein Verstärker vergrößert elektrische Signale, die am Eingang zugeführt werden, indem elektrische Energie aus einer Gleichstromquelle gesteuert wird. Es lassen sich Spannungen, Ströme und Leistungen verstärken. Historisch basierten die ersten Verstärker auf Elektronenröhren, später wurden diese durch Transistoren ersetzt.'
  },
  {
    term: 'Wackelkontakt',
    description:
      'Unregelmäßiges, ungewolltes Unterbrechen eines Stromkreises durch schlechte Kontakte an Schaltern, Steckern, Leitungen oder Fassungen. Auch als Wackler bezeichnet. Kann durch Alterung und Verschleiß von Bauteilen (z.B. Oxidation) entstehen.'
  },
  {
    term: 'Wechselschaltung',
    description:
      'Solch eine Schaltung wird in Elektroinstallationen in Gebäuden benutzt, um Verbraucher (Lampen) von zwei verschiedenen Stellen ein- und auszuschalten. Z.B. läßt sich in einem langen Flur eine Deckenbeleuchtung an beiden Eingängen wahlweise schalten. Technisch realisiert wird die Wechselschaltung mit zwei Wechselschaltern, die jeweils drei Anschlüsse besitzen.'
  },
  {
    term: 'Wechselblinker',
    description:
      'Eine oft aufgebaute Elektronikschaltung, die im Modellbau oder als Warnblinker Einsatz findet. Sie wird auch als astabiler Multivibrator bezeichnet. Sie besteht aus zwei Transistoren, die abwechselnd leiten und sperren. Ein Lämpchen oder LED am Kollektor des leitenden Transistors leuchtet und diejenige am Kollektor des sperrenden Transistors bleibt dunkel.'
  },
  {
    term: 'Wechselspannung',
    description:
      'Die elektrische Spannung besitzt zwei Pole - den positiven Pluspol und den negativen Minuspol. Ändert eine Spannungsquelle ihre Polarität periodisch, dann handelt es sich um eine Wechselspannungsquelle. Plus und Minus wechseln im Zeitverlauf ständig, so dass der zeitliche Mittelwert der Spannung Null ist. Die Kurvenform einer Wechselspannung ist oft eine Sinuskurve, es sind aber auch andere Formen möglich. Die Frequenz beschreibt die Anzahl der periodischen Schwingungen pro Zeiteinheit.'
  },
  {
    term: 'Wechselstrom',
    description:
      'Fließt von einer Wechselspannungsquelle ausgehend ein Strom, dann handelt es sich um Wechselstrom, der periodisch seine Polarität und seinen Wert (Stromstärke) ändert. Wechselspannung entsteht im Wechselstromgenerator. Dabei ist die Frequenz proportional zur Rotordrehzahl.'
  },
  {
    term: 'Wechselschalter (auch Umschalter, Wechsler)',
    description: 'Dieser Schalter mit meist drei Anschlüssen schließt bei Betätigung einen Stromkreis, während gleichzeitig ein anderer Stromkreis geöffnet wird.'
  },
  {
    term: 'Widerstand',
    description:
      'Das sog. Ohmsche Gesetz besagt, dass in einem Stromkreis die Stromstärke immer proportional zur angelegten Spannung ist. Der Proportionalitätsfaktor ist der elektrische Widerstand. Wenn man die Formelzeichen U für Spannung, I für Strom und R für Widerstand benutzt, dann lautet das Ohmsche Gesetz als Formel: U= R * I. In der Elektronik sind Widerstände passive Bauelemente, die dazu dienen, Strom zu begrenzen oder Strom in Spannung zu wandeln.'
  },
  {
    term: 'Wippschalter',
    description:
      'Bauform eines Schalters, bei dem ein Stromkreis geöffnet oder geschlossen wird, indem das Schaltelement in Form einer Wippe betätigt wird. Eine häufige Anwendung sind Lichtschalter, aber auch der Schalter von Mehrfachsteckdosen hat oft die Form einer Wippe. Sehr oft sind Wippschalter beleuchtet und zeigen so den Schaltzustand optisch an.'
  },
  {
    term: 'Wirbelstrom',
    description:
      'Befindet sich ein massiver leitender Körper in einem magnetischen Wechselfeld oder wird er in einem Magnetfeld bewegt, so werden im Körper Spannungen induziert, die das Fließen von Strömen verursachen. Diese Ströme durchfließen den Körper im Inneren auf geschlossenen Bahnen (wirbelartig) - daher nennt man sie Wirbelströme. Sie rufen nach der Lenzschen Regel Magnetfelder hervor, die die Bewegung des Leiters hemmen. Wirbelströme führen auch zur Erwärmung des Metallkörpers und werden bei einer Induktionsheizung genutzt.'
  },
  {
    term: 'Wirbelstrombremse',
    description:
      'Nutzt die Tatsache aus, dass die Bewegung eines leitenden Körpers in einem Magnetfeld Wirbelströme erzeugt, die nach der Lenzschen Regel wieder eigene Magnetfelder erzeugen, die dem äußeren Magnetfeld entgegenwirken und dadurch diese Bewegung hemmen und abbremsen. Technisch von Bedeutung ist diese Art Bremswirkung, weil sie ohne direkte Berührung des abzubremsenden Teils zustande kommt und dadurch keinen Verschleiß zeigt. Wirbelstrombremsen kommen u.a. bei Schienenfahrzeugen zum Einsatz.'
  },
  {
    term: 'XODER-Schaltung',
    description:
      'Logikschaltung, die die mathematische Operation EXKLUSIVES ODER umsetzt. Realisiert werden kann dies durch zwei Wechselschalter mit umgekehrter Anschlußbelegung. Strom durch den Stromkreis nur fließen, wenn entweder der eine oder der andere Schalter geschlossen sind. Sind beide gleichzeitig geschlossen oder offen, fließt kein Strom.'
  },
  {
    term: 'Zenerdiode',
    description: 'Spezielle Siliziumdiode zur Stabilisierung einer Gleichspannung, wird in Sperrichtung betrieben.'
  },
  {
    term: 'SDA',
    description: 'Die Datenleitung (SDA = Serial Data) eines <a href="https://de.wikipedia.org/wiki/I%C2%B2C" target="_blank">I<sup>2</sup>C (serieller Datenbus)</a>.'
  },
  {
    term: 'SCL',
    description: 'Die Taktleitung (SCL = Serial Clock) eines <a href="https://de.wikipedia.org/wiki/I%C2%B2C" target="_blank">I<sup>2</sup>C (serieller Datenbus)</a>.'
  },
  {
    term: 'TXD',
    description: 'Leitung für ausgehende Daten (Transmit Data) bei <a href="https://de.wikipedia.org/wiki/RS-232" target="_blank">RS-232 (Standard für eine serielle Schnittstelle)</a>.'
  },
  {
    term: 'RXD',
    description: 'Leitung für eingehende Daten (Receive Data) bei <a href="https://de.wikipedia.org/wiki/RS-232" target="_blank">RS-232 (Standard für eine serielle Schnittstelle)</a>.'
  },
  {
    term: 'MOSI',
    description: 'Master Output, Slave Input. Eine der drei gemeinsamen Leitungen die bei <a href="https://de.wikipedia.org/wiki/Serial_Peripheral_Interface" target="_blank">SPI (Serial Peripheral Interface)</a> an jeden Teilnehmer angeschlossen ist.'
  },
  {
    term: 'MISO',
    description: 'Master Input, Slave Output. Eine der drei gemeinsamen Leitungen die bei <a href="https://de.wikipedia.org/wiki/Serial_Peripheral_Interface" target="_blank">SPI (Serial Peripheral Interface)</a> an jeden Teilnehmer angeschlossen ist.'
  },
  {
    term: 'SCLK',
    description: 'Serial Clock. Eine der drei gemeinsamen Leitungen die bei <a href="https://de.wikipedia.org/wiki/Serial_Peripheral_Interface" target="_blank">SPI (Serial Peripheral Interface)</a> an jeden Teilnehmer angeschlossen ist.'
  }
]
